export default function OptionGif({ video }: { video: any }) {
    return (
        <div className="col-span-1 flex flex-col justify-center items-start pr-5 lg:pr-0">
            <div className="w-full lg:w-5/6 max-w-[102px] h-[188px] border border-skeleton shadow-skeleton rounded-2xl overflow-hidden">
                <img src={`/gif/${video}.gif`} alt={video} className="w-full h-full object-cover" />
            </div>
        </div>
    )
}